import { styled } from '@linaria/react';
import { semantic, size, space } from '../../theme/tokens';

export const StyledCardSelectButton = styled.a`
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  text-align: inherit;
  text-transform: inherit;
  text-decoration: none;
  cursor: pointer;

  &:focus-visible {
    outline: ${size.stroke['stroke-thick']} solid ${semantic.border.selected};
    outline-offset: ${space['space-050']};
  }
`;
